import React from 'react'
import "./style.css";

export default function Footer() {
    return (
        <div className="footer">
        <div className="container">
            <div className="row align-items-center">
            <div className="col-12 text-center">
                <div className="copyright-content">
                <p className="mb-0">
                    Copyright © 2022 <a href="https://mofaga.gov.np" target="_blank">MOFAGA</a> All Rights Reserved.
                </p>
                </div>
            </div>
            </div>
        </div>
        </div>
    )
}
